import styled, { css } from 'styled-components';

interface IFeatures {
  zIndex: number;
}

interface IModal {
  zIndex: number;
}

export const Wrapper = styled.div`
  ${({ }) => css`
    display: grid;
  `}
`;

export const Modal = styled.div<IModal>`
  ${({ zIndex }) => css`
    display: inline-block;
    z-index: ${zIndex};
  `}
`;

export const Features = styled.div<IFeatures>`
  ${({ theme, zIndex }) => css`
    position: absolute;
    z-index: ${zIndex};
    pointer-events: none;

    p {
      font-family: ${theme.font.family.default};
    }
  `}
`;

export const Content = styled.div`
  ${({ }) => css``}
`;
